import { render, staticRenderFns } from "./ShorexSwiper.vue?vue&type=template&id=974a797e&scoped=true"
import script from "./ShorexSwiper.vue?vue&type=script&lang=js"
export * from "./ShorexSwiper.vue?vue&type=script&lang=js"
import style0 from "./ShorexSwiper.vue?vue&type=style&index=0&id=974a797e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974a797e",
  null
  
)

export default component.exports